export default __webpack_public_path__ + "media/images/main/spinner-d29a6e317891191e5b3208c91a90ea4d.svg";